import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class UserStateDispatcher extends Component {
  componentWillMount() {
    this.props.fetchUserStateByRegistrationId();
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}

const mapStateToProps = state => ({
  user: state.user,
  isAuthenticated: state.user.isAuthenticated,
});

const mapDispatchToProps = dispatch => ({
  fetchUserStateByRegistrationId: () =>
    dispatch({ type: 'FETCH_REGISTRATION_STATE', userId: null }),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserStateDispatcher)
);



// WEBPACK FOOTER //
// ./src/_app/UserStateDispatcher.jsx